var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8431 15.2426C18.1863 12.8995 18.1863 9.1005 15.8431 6.75736C13.5 4.41421 9.70101 4.41421 7.35786 6.75736C5.01472 9.1005 5.01472 12.8995 7.35786 15.2426C9.70101 17.5858 13.5 17.5858 15.8431 15.2426ZM17.2574 5.34315C20.1425 8.22833 20.3633 12.769 17.9195 15.9075C17.9348 15.921 17.9498 15.9351 17.9645 15.9497L22.2071 20.1924C22.5976 20.5829 22.5976 21.2161 22.2071 21.6066C21.8166 21.9971 21.1834 21.9971 20.7929 21.6066L16.5503 17.364C16.5356 17.3493 16.5215 17.3343 16.508 17.319C13.3695 19.7628 8.82883 19.542 5.94365 16.6569C2.81946 13.5327 2.81946 8.46734 5.94365 5.34315C9.06785 2.21895 14.1332 2.21895 17.2574 5.34315Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoomIn.8912f1307dd8ca74b56f44e24c284a45.svg";
export { ForwardRef as ReactComponent };